import { Form, Spin, Input, Select } from "antd";
import { Button as PrimeBtn } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import {
    updateProjectInvoice,
} from "../../../apis/AdminApis";

const UpdateProjectInvoiceDialog = (props) => {
    const [apiLoading, setApiLoading] = useState(false);
    const toast = useRef(null);
    const [form] = Form.useForm();
    const { Option } = Select;
    const dropdownStyles = {
        zIndex: 10000,
        minWidth: "270px"
    };
    useEffect(() => {
        if(props.dialogMode == "Update"){
            form.setFieldsValue({ ...props.projectInvoice })
        }else{
            form.resetFields();
            form.setFieldsValue({ companyId : props.companyId })
        }
    });

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            if(props.dialogMode === "Update"){
                values.id = props.projectInvoice.id;
                values.company = { id: props.projectInvoice.company.id };
            }else{
                values.company = { id: values.companyId };
            }
            
            setApiLoading(true);
            updateProjectInvoice(values).then((res) => {
                if (res.status === 200) {
                    toast.current.show({
                        severity: "success",
                        summary: "Status",
                        detail: `${props.dialogMode} Project Invoice successfully, Add Default User Invoice Config If Not Exists`,
                        life: 5000
                    })

                    setApiLoading(false);
                    props.setVisible(false);
                } else {
                    toast.current.show({
                        severity: "warn",
                        summary: "Status",
                        detail: `${props.dialogMode} Project Invoice Failed`,
                        life: 3000
                    })
                    setApiLoading(false);
                    props.setVisible(false);
                }
            }).catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
        })
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />
            <Dialog
                style={{ width: "480px" }}
                header={`${props.dialogMode} Project Invoice Config`}
                visible={props.visible}
                onHide={() => { props.setVisible(false) }}
            >
                <Spin spinning={apiLoading} >
                    <React.Fragment>
                        <div className='flex justify-content-between align-items-center'>
                            <Form form={form} onFinish={handleSubmit}>
                                {props.dialogMode == "Create" ?
                                    (<Form.Item
                                        rules={[
                                            {
                                                required: true,
                                                message: "Customer is required.",
                                            },
                                        ]}
                                        labelCol={{ span: 9 }}
                                        labelAlign={"left"}
                                        name="companyId"
                                        label="Customer"
                                    >
                                        <Select
                                            mode={"single"}
                                            dropdownStyle={dropdownStyles}
                                            placeholder="Select Customer"
                                            style={{ width: 270 }}
                                            options={props?.companyOptions}>
                                        </Select>
                                    </Form.Item>) : ("")}
                                <Form.Item required={true}
                                    name="product" label="Product"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Product is required.",
                                        },
                                    ]}
                                >
                                    <Select style={{ width: 270 }} dropdownStyle={{ zIndex: "9999" }} placeholder="Select">
                                        <Option value="Bog">Bog</Option>
                                        <Option value="House">House</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item required={true}
                                    name="type" label="Type"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select House Type",
                                        },
                                    ]}
                                >
                                    <Select style={{ width: "270px" }} dropdownStyle={{ zIndex: "9999" }} placeholder="Select">
                                        <Option value="A">A</Option>
                                        <Option value="B">B</Option>
                                        <Option value="C">C</Option>
                                        <Option value="D">D</Option>
                                        <Option value="E">E</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item required={true}
                                    name="ndd" label="Ndd"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Select style={{ width: 270 }} dropdownStyle={{ zIndex: "9999" }} placeholder="Select">
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item required={true}
                                    name="isAutocad" label="Autocad"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Select style={{ width: 270 }} dropdownStyle={{ zIndex: "9999" }} placeholder="Select">
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item required={true}
                                    name="price" label="Price"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Input
                                        style={{ width: "270px" }}
                                        onKeyDown={(e) => e.stopPropagation()}
                                    />
                                </Form.Item>
                                <Form.Item required={true}
                                    name="report" label="Report"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Select style={{ width: 270 }} dropdownStyle={{ zIndex: "9999" }} placeholder="Select">
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                </Form.Item>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <PrimeBtn
                                        style={{
                                            backgroundColor: "#037eea",
                                            borderColor: "#037eea",
                                            float: "right",
                                            marginRight: "1rem",
                                        }}
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </Form>
                        </div>
                    </React.Fragment>
                </Spin>

            </Dialog>
        </React.Fragment>
    )
}

export default UpdateProjectInvoiceDialog
